module.exports = "https://cdn.hellotech.com/client-assets/HT_techGlenn_a4d5c5e91fa2fd548c71667521c3f3a1.jpg";